var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nmain[data-v-0e184967] {\n  position: relative;\n  padding: 2rem 0;\n  height: calc(100vh - 3.4rem);\n  text-align: center;\n}\nmain .inner[data-v-0e184967] {\n  position: relative;\n  padding-bottom: 8rem;\n}\nmain[data-v-0e184967]::before {\n  background: url(" + escape(require("../../public/afterparty-solomun.jpg")) + ") center center;\n  background-size: cover;\n  content: \"\";\n  opacity: 0.2;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n}\n", ""]);

// exports
